import { UseMutationResult, useMutation, useQueryClient } from "@tanstack/react-query";

import { splitField } from "services";

import { getFarmIdFromLocalStorage } from "utils";

import { FOOTPRINTING_CROP_ASSESSMENTS_REQUIRING_REVIEW, GET_FIELDS, SPLIT_FIELD } from "consts";

import { Area } from "models";

export type SplitFieldRequestBody = {
  splitAreas: Area[];
  fieldId: string;
  splitDate: string;
};

export type SplitFieldResponse = {
  splitFieldIds: string[];
};

export const useSplitField = (): UseMutationResult<SplitFieldResponse, Error, SplitFieldRequestBody> => {
  const queryClient = useQueryClient();
  const farmId = getFarmIdFromLocalStorage();

  return useMutation({
    mutationKey: [SPLIT_FIELD],
    mutationFn: splitField,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FIELDS] });
      queryClient.invalidateQueries({ queryKey: [FOOTPRINTING_CROP_ASSESSMENTS_REQUIRING_REVIEW, farmId] });
    },
  });
};
